import { render, staticRenderFns } from "./apigetzhrzhq.vue?vue&type=template&id=77021721"
import script from "./apigetzhrzhq.vue?vue&type=script&lang=js"
export * from "./apigetzhrzhq.vue?vue&type=script&lang=js"
import style0 from "./apigetzhrzhq.vue?vue&type=style&index=0&id=77021721&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports